export default "Remplacement de fenêtres double vitrage 2026 — Aides MPR + CEE | Solution Éco France";
